import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => ({
	note: {
		marginBottom: 16,
	},
	warn: {
		marginBottom: 16,
		color: "#7A4D00",
	},
	field: {
		marginBottom: 16,
	},
	board: {
		marginBottom: 16,
	},
	boardLabel: {
		color: theme.palette.text.secondary,
		fontSize: 12,
	},
	clear: {
		marginRight: "auto",
	},
} satisfies Record<string, CSSObject>);
